import React, { useState } from 'react';

import data from '../data.json';
import { useChecklistContext } from '../../../context/checklistContext';

import YesNoButton from './YesNoButton';

export default function Checklist() {
  const alldata = data;

  const { setIDCheck } = useChecklistContext();

  const [questions, setQuestions] = useState(alldata.questions);
  const [activeComment, setActiveComment] = useState(0);
  const [responses, setResponses] = useState({});

  const handleResponse = (id, value) => {
    setActiveComment(id);
    setIDCheck(id);
    setResponses((prev) => ({ ...prev, [id]: value }));
  };

  const handleComment = (id) => {
    setIDCheck(id);
    setActiveComment(id);
  };

  const handleTextArea = (e, id) => {
    const value = e.target.value;
    setResponses((prev) => ({ ...prev, [id]: value }));
    setIDCheck(id);
    setActiveComment(id);
  };

  return (
    <div className="checklist-container">
      {questions.map((question) => (
        <div className="checklist" key={question.id}>
          <div className="checklist-heading">
            <p>{question.text}</p>
          </div>
          <div className="checklist-action">
            {question.type === 'yesNo' ? (
              <div className="buttonYesNo">
                <YesNoButton
                  id={question.id}
                  value="no"
                  active={responses[question.id] === 'no'}
                  onClick={handleResponse}
                  label="NÃO"
                  icon="❌"
                />
                <YesNoButton
                  id={question.id}
                  value="yes"
                  active={responses[question.id] === 'yes'}
                  onClick={handleResponse}
                  label="SIM"
                  icon="✅"
                />
              </div>
            ) : (
              <div className="textArea">
                <textarea
                  id={question.id}
                  className="text-input"
                  maxLength="500"
                  placeholder="Digite sua resposta aqui..."
                  value={responses[question.id] || ''}
                  onChange={(e) => handleTextArea(e, question.id)}
                  onClick={(e) => handleTextArea(e, question.id)}
                />
                <div className="text-counter">
                  {responses[question.id]?.length || 0}/500
                </div>
              </div>
            )}
          </div>
          <div
            className="checklist-comments"
            onClick={() => handleComment(question.id)}
          >
            <span className="checklist-comments-title">Comentar 💬</span>
          </div>
        </div>
      ))}
    </div>
  );
}
